module.exports = __webpack_public_path__ + "img/hr-branch-particle-25.8396df7d.png";